import React, { useRef } from "react";
import { Routes, Navigate, Route } from "react-router-dom";
import Signup from "../../components/Signup/Signup";
import Login from "../../components/Login/Login";
import Induction from "../../components/Induction/Induction";
import Protective from "../../components/Protective/Protective";
import Questionnaire from "../../components/Questionnaire/Questionnaire";
import EmailVerification from "../../components/EmailVerification/EmailVerification";
import SuccessVerification from "../../components/EmailVerification/SuccessVerification";
import Mcq from "../../components/Mcq/Mcq";
import CreateRole from "../../components/Pages/CreateRole/CreateRole";
import CreateUser from "../../components/Pages/CreateUser/CreateUser";
import CreateSuperAdmin from "../../components/Pages/CreateUser/CreateSuperAdmin";
import Register from "../../components/Signup/Register";
import AptitudeTest from "../../components/Signup/AptitudeTest";
import ForgotPassword from "../../components/ForgotPassword/ForgotPassword";
import ChangePassword from "../../components/ForgotPassword/ChangePassword";
import McqResult from "../../components/Mcq/McqResult";
import Dashboard from "../../components/Pages/AdminPanel/AdminPanel";
import Setting from "../../components/Pages/Setting/Setting";
import Tenants from "../../components/Pages/Tenants/Tenants";
import Users from "../../components/Pages/Users/Users";
import ChangeAccountPassword from "../../components/Pages/ChangeAccountPassword/ChangeAccountPassword";
import TenantUsers from "../../components/Pages/Users/TenantUsers";
import ManageMCQ from "../../components/Pages/ManageMCQ/ManageMCQ";
import AddMCQ from "../../components/Pages/ManageMCQ/AddMCQ";
import Components from "../../components/Pages/Components/Components";
import AddComponents from "../../components/Pages/Components/AddComponents";
import Actions from "../../components/Pages/Actions/Actions";
import AddActions from "../../components/Pages/Actions/AddActions";
import EditMCQ from "../../components/Pages/ManageMCQ/EditMCQ";
import ViewMCQ from "../../components/Pages/ManageMCQ/ViewMCQ";
import McqFail from "../../components/Mcq/McqFail";
import UserHealth from "../../components/Pages/Users/UserHealth";
import Designations from "../../components/Pages/Designations/Designations";
import AddDesignations from "../../components/Pages/Designations/AddDesignations";
import AddDepartments from "../../components/Pages/Departments/AddDepartments";
import Departments from "../../components/Pages/Departments/Departments";
import EditDepartments from "../../components/Pages/Departments/EditDepartments";
import EditDesignations from "../../components/Pages/Designations/EditDesignations";
import Complains from "../../components/Pages/Complains/Complains";
import CreateComplains from "../../components/Pages/Complains/CreateComplains";
import ReplyComplain from "../../components/Pages/Complains/ReplyComplain";
import HierarchyTable from "../../components/Pages/Designations/HierarchyTable";
import Product from "../../components/Pages/Product/Product";
import Suppliers from "../../components/Pages/Suppliers/Suppliers";
import AddSuppliers from "../../components/Pages/Suppliers/AddSuppliers";
import EditSuppliers from "../../components/Pages/Suppliers/EditSuppliers";
import GoodInward from "../../components/Pages/GoodInward/GoodInward";
import Allergens from "../../components/Pages/Allergens/Allergens";
import AddAllergens from "../../components/Pages/Allergens/AddAllergens";
import EditAllergens from "../../components/Pages/Allergens/EditAllergens";
import OpenShelfLife from "../../components/Pages/OpenShelfLife/OpenShelfLife";
import AddOpenShelfLife from "../../components/Pages/OpenShelfLife/AddOpenShelfLife";
import CoolingShelf from "../../components/Pages/CoolingShelf/CoolingShelf";
import AddCoolingShelf from "../../components/Pages/CoolingShelf/AddCoolingShelf";
import EditCoolingShelf from "../../components/Pages/CoolingShelf/EditCoolingShelf";
import ManageAccount from "../../components/Pages/ManageAccount/ManageAccount";
import Recipe from "../../components/Pages/Recipe/Recipe";
import Stock from "../../components/Stock/Stock";
import AddIngredients from "../../components/Pages/Ingredients/AddIngredients";
import EditIngredients from "../../components/Pages/Ingredients/EditIngredients";
import Ingredients from "../../components/Pages/Ingredients/Ingredients";
import AfterCook from "../../components/AfterCook/AfterCook";
import AddRecipe from "../../components/Pages/Recipe/AddRecipe";
import EditRecipe from "../../components/Pages/Recipe/EditRecipe";
import Production from "../../components/Production/Production";
import ListAfterCook from "../../components/AfterCook/ListAfterCook";
import UserRole from "../../components/Pages/Users/UserRole";
import CoolingProcess from "../../components/CoolingProcess/CoolingProcess";
import CleaningTraceabilityItem from "../../components/Pages/CleaningTraceabilityItem/CleaningTraceabilityItem";
import AddCleaningTraceabilityItem from "../../components/Pages/CleaningTraceabilityItem/AddCleaningTraceabilityItem";
import EditCleaningTraceabilityItem from "../../components/Pages/CleaningTraceabilityItem/EditCleaningTraceabilityItem";
import Reheat from "../../components/Reheat/Reheat";
import CleaningTraceability from "../../components/CleaningTraceability/CleaningTraceability";
import DailyCleaningTraceability from "../../components/CleaningTraceability/DailyCleaningTraceability";
import MonthlyCleaningTraceability from "../../components/CleaningTraceability/MonthlyCleaningTraceability";
import WeeklyCleaningTraceability from "../../components/CleaningTraceability/WeeklyCleaningTraceability";
import HotHold from "../../components/HotHold/HotHold";
import Subtenants from "../../components/Subtenants/Subtenants";
import AddSubtenants from "../../components/Subtenants/AddSubtenants";
import EditSubtenants from "../../components/Subtenants/EditSubtenants";
import { notification } from "antd";
import ColdTraceability from "../../components/ColdTraceability/ColdTraceability";
import StockList from "../../components/Stock/StockList";
import AddUserTenant from "../../components/Pages/CreateUser/AddUserTenant";
import SubtenantsUnterUser from "../../components/Subtenants/SubtenantsUnterUser";
import AddAlert from "../../components/Pages/Alert/AddAlert";
import Alerts from "../../components/Pages/Alert/Alerts";
import EditAlert from "../../components/Pages/Alert/EditAlert";
import StorageSuggestion from "../../components/Pages/StorageSuggestion/Storage";
import AddStorageSuggestion from "../../components/Pages/StorageSuggestion/AddStorageList";
import EditStorageSuggestion from "../../components/Pages/StorageSuggestion/EditStorageList";
import Storage from "../../components/Pages/StorageList/StorageList";
import AddStorage from "../../components/Pages/StorageList/AddStorageList";
import EditStorage from "../../components/Pages/StorageList/EditStorageList";
import EditSensor from "../../components/Pages/Sensor/EditSensor";
import AddSensor from "../../components/Pages/Sensor/AddSensor";
import Sensor from "../../components/Pages/Sensor/Sensor";
import StorageSensor from "../../components/Pages/StorageSensor/StorageSensor";
import AddStorageSensor from "../../components/Pages/StorageSensor/AddStorageSensor";
import EditStorageSensor from "../../components/Pages/StorageSensor/EditStorageSensor";
import AddStorageInstructions from "../../components/Pages/StorageInstructions/AddStorageInstructions";
import EditStorageInstructions from "../../components/Pages/StorageInstructions/EditStorageInstructions";
import StorageInstructions from "../../components/Pages/StorageInstructions/StorageInstructions";
import AddTwilioConfigurations from "../../components/Pages/TwilioConfigurations/AddTwilioConfigurations";
import TwilioConfigurations from "../../components/Pages/TwilioConfigurations/TwilioConfigurations";
import EditTwilioConfigurations from "../../components/Pages/TwilioConfigurations/EditTwilioConfigurations";
import WasteReports from "../../components/Reports/WasteReports";
import RawWasteReports from "../../components/Reports/RawWasteReports";
import InventoryReports from "../../components/Reports/InventoryReports";
import CreateSubTenantUser from "../../components/Pages/CreateUser/CreateSubTenantUser";
import SensorDashboard from "../../components/Pages/SensorDashboard/SensorDashboard";
import FridgeTemperatureReport from "../../components/Reports/FridgeTemperatureReport";
import SensorApiConfigurations from "../../components/Pages/SensorApiConfigurations/SensorApiConfigurations";
import CurrencyConfigurations from "../../components/Pages/CurrencyConfigurations/CurrencyConfigurations";
import ProductionStockList from "../../components/Production/ProductionStockList";
import ViewSingleProduct from "../../components/Pages/Product/ViewSingleProduct";
import LiveSensor from "../../components/Pages/StorageList/LiveSensor";
import SensorAlerts from "../../components/Pages/SensorDashboard/SensorAlerts";
import CleaningTraceabilityDepartment from "../../components/CleaningTraceability/CleaningTraceabilityDepartment";
import TimeApiConfigurations from "../../components/Pages/TimeApiConfigurations/TimeApiConfigurations";
import AllergensSheet from "../../components/AllergensSheet/AllergensSheet";
import VideoApiConfigurations from "../../components/Pages/VideoApiConfigurations/VideoApiConfigurations";
import TermsApiConfigurations from "../../components/Pages/TermsApiConfigurations/TermsApiConfigurations";
import UserProtective from "../../components/Pages/Users/UserProtective";
import ComapnyProfile from "../../components/Pages/Tenants/Profile";
import CodeLogin from "../../components/Login/CodeLogin";
import OnboardedUsers from "../../components/Pages/Users/OnboardedUsers";
import TenantAuditTrail from "../../components/Pages/Tenants/TenantAuditTrail";
import SubTenantsUnderTenant from "../../components/Pages/Tenants/SubTenantsUnderTenant";
import UserLogs from "../../components/Pages/Users/logs";
import McqAns from "../../components/Pages/Users/McqAns";
import CleaningTraceabilityAreas from "../../components/Pages/CleaningTraceabilityItem/CleaningTraceabilityAreas";
import CleaningTraceabilityReport from "../../components/Reports/CleaningTraceabilityReport";
import StockAdjustmentReports from "../../components/Reports/StockAdjustmentReport";
import AftercookReport from "../../components/Reports/AftercookReport";
import ColdTraceabilityReport from "../../components/Reports/ColdTrceabilityReport";
import HotHoldReport from "../../components/Reports/HotHoldReport";
import CoolingProcessReport from "../../components/Reports/CoolingProcessReport";
import ReheatProcessReport from "../../components/Reports/ReheatProcessReport";
// import SubTenantsUnderTenant from "../../components/Pages/Tenants/SubTenantsUnderTenant";




const RouteConfig = () => {

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const RequireAuth = ({ element }) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  if (!decodedToken) {
    return <Navigate to="/" replace />;
  }

  return element;
};

  const privilagesAccess = () => {

    notification.open({
      message: <span style={{ fontWeight: "bold" }}>Error</span>,
      description: "You are not authorised to access this page. Please contact your admin.",
      closeIcon: false,
      duration: 3,
      style: {
        backgroundColor: "#ffb3b3",
        color: "red",
      },
    });

  };
  const ProtectedRoute = ({ permissions, element }) => {
    const hasPermissions = permissions.every(permission =>
      decodedToken?.permissions?.some(p => p.authority === permission)
    );
    if (!hasPermissions) {
      privilagesAccess();
      return <Navigate to="/dashboard" />;
    }
    return element;
  };

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/induction" element={<Induction />} />
      <Route path="/test" element={<Mcq />} />
      <Route path="/test-result" element={<McqResult />} />
      <Route path="/test-fail" element={<McqFail />} />
      <Route path="/protective" element={<Protective />} />
      <Route path="/questionnaire" element={<Questionnaire />} />
      <Route path="/email-verification" element={<EmailVerification />} />
      <Route path="/register" element={<Register />} />
      <Route path="/aptitude-test" element={<AptitudeTest />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/code-login" element={<CodeLogin />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/register-success" element={<SuccessVerification />} />
      <Route path="/dashboard" element={<RequireAuth element={<Dashboard />} />} />
      <Route path="/settings" element={<Setting />} />
      <Route path="/settings/set-permissions" element={<ProtectedRoute permissions={['VIEW_PERMISSION']} element={<CreateRole />} />} />
      
      <Route path="/settings/terms-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<TermsApiConfigurations />} />} />
      <Route path="/settings/video-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<VideoApiConfigurations />} />} />
      <Route path="/settings/time-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<TimeApiConfigurations />} />} />
      <Route path="/settings/twilio-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<TwilioConfigurations />} />} />
      <Route path="/settings/sensor-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<SensorApiConfigurations />} />} />
      <Route path="/settings/currency-configurations" element={<ProtectedRoute permissions={['VIEW_RUNTIME_CONFIG']} element={<CurrencyConfigurations />} />} />
      <Route path="/settings/twilio-configurations/add-twilio-configurations" element={<ProtectedRoute permissions={['ADD_RUNTIME_CONFIG']} element={<AddTwilioConfigurations />} />} />
      <Route path="/settings/edit-configurations" element={<ProtectedRoute permissions={['EDIT_RUNTIME_CONFIG']} element={<EditTwilioConfigurations />} />} />

      <Route path="/tenants" element={<Tenants />} />
      <Route path="/tenants/users" element={<TenantUsers />} />
      <Route path="/tenants/sub-tenants" element={<SubTenantsUnderTenant />} /> 
      <Route path="/tenant/audit-trail" element={<TenantAuditTrail />} />
      <Route path="/onboarded-users" element={<OnboardedUsers />} />
      <Route path="/users" element={<Users />} />
      <Route path="/users/health" element={<UserHealth />} />
      <Route path="/users/mcq-answers" element={<McqAns />} />
      <Route path="/users/user-role" element={<UserRole />} />
      <Route path="/users/invite-users" element={<CreateUser />} />
      <Route path="/users/invite-tenant-users" element={<CreateSuperAdmin />} />
      <Route path="/users/invite-sub-tenants-users" element={<CreateSubTenantUser />} />
      <Route path="/users/add-users" element={<AddUserTenant />} />
      <Route path="/users/protective-clothing" element={<UserProtective />} />
      <Route path="/change-newpassword" element={<ChangeAccountPassword />} />
      <Route path="/manage-account" element={<ManageAccount />} />
      <Route path="/masters/MCQ-management" element={<ManageMCQ />} />
      <Route path="/masters/MCQ-management/add-MCQ" element={<AddMCQ />} />
      <Route path="/masters/MCQ-management/edit-MCQ" element={<EditMCQ />} />
      <Route path="/masters/MCQ-management/view-MCQ" element={<ViewMCQ />} />
      <Route path="/masters/components" element={<Components />} />
      <Route path="/components/add-components" element={<AddComponents />} />
      <Route path="/masters/actions" element={<ProtectedRoute permissions={['VIEW_ACTION']} element={<Actions />} />} />
      <Route path="/masters/alerts/add-alert" element={<ProtectedRoute permissions={['VIEW_ALERT']} element={<AddAlert />} />} />
      <Route path="/masters/alerts" element={<ProtectedRoute permissions={['VIEW_ALERT']} element={<Alerts />} />} />
      <Route path="/masters/alerts/edit-alert" element={<ProtectedRoute permissions={['VIEW_ALERT']} element={<EditAlert />} />} />
      <Route path="/masters/add-actions" element={<ProtectedRoute permissions={['ADD_ACTION']} element={<AddActions />} />} />

      <Route path="/masters/designations" element={<Designations />} />
      <Route path="/reheat" element={<ProtectedRoute permissions={['VIEW_REHEAT_PROCESS']} element={<Reheat />} />} />
      <Route path="/masters/recipe" element={<Recipe />} />
      <Route path="/masters/recipe/add-recipe" element={<AddRecipe />} />
      <Route path="/masters/recipe/edit-recipe" element={<EditRecipe />} />
      <Route path="/stock" element={<Stock />} />
      <Route path="/stock-list" element={<StockList />} />
      <Route path="/live-stock" element={<ProductionStockList />} />
      <Route path="/sensor-alerts" element={<SensorAlerts />} />
      <Route path="/sensor-dashboard" element={<SensorDashboard />} />
      <Route path="/masters/ingredients" element={<Ingredients />} />
      <Route path="/masters/ingredients/add-ingredients" element={<AddIngredients />} />
      <Route path="/masters/ingredients/edit-ingredients" element={<EditIngredients />} />
      <Route path="/cleaning-traceability/cleaning-list/add-cleaning-traceability-item" element={<AddCleaningTraceabilityItem />} />
      <Route path="/cleaning-traceability/cleaning-list/edit-cleaning-traceability-item" element={<EditCleaningTraceabilityItem />} />
      <Route path="/cleaning-traceability/cleaning-list" element={<CleaningTraceabilityItem />} />
      <Route path="/cleaning-traceability/cleaning-areas" element={<CleaningTraceabilityAreas />} />
      <Route path="/allergens-sheet" element={<AllergensSheet />} />
      <Route path="/cleaning-traceability" element={<CleaningTraceability />} />
      <Route path="/cleaning-traceability/:departmentName" element={<CleaningTraceabilityDepartment />} />
      <Route path="/daily-cleaning-traceability" element={<DailyCleaningTraceability />} />
      <Route path="/weekly-cleaning-traceability" element={<WeeklyCleaningTraceability />} />
      <Route path="/monthly-cleaning-traceability" element={<MonthlyCleaningTraceability />} />
      <Route path="/hot-hold" element={<ProtectedRoute permissions={['VIEW_HOT_HOLD']} element={<HotHold />} />} />
      <Route path="/cold-traceability" element={<ProtectedRoute permissions={['VIEW_COLD_TRACEABILITY']} element={<ColdTraceability />} />} />
      <Route path="/sub-tenants" element={<Subtenants />} />
      <Route path="/sub-tenants/:subTenantName/users" element={<SubtenantsUnterUser />} />
      <Route path="/sub-tenants/add-sub-tenants" element={<AddSubtenants />} />
      <Route path="/sub-tenants/edit-sub-tenants" element={<EditSubtenants />} />
      <Route
        path="/masters/designations/hierarchy-table"
        element={<HierarchyTable />}
      />
      <Route
        path="/masters/designations/edit-designation"
        element={<EditDesignations />}
      />
      <Route
        path="/masters/designations/add-designation"
        element={<AddDesignations />}
      />
      <Route path="/masters/departments" element={<Departments />} />
      <Route
        path="/masters/departments/edit-department"
        element={<EditDepartments />}
      />
      <Route
        path="/masters/departments/add-department"
        element={<AddDepartments />}
      />
      <Route path="/complaints" element={<Complains />} />
      <Route
        path="/complaints/create-complaint"
        element={<CreateComplains />}
      />
      <Route path="/reports/waste-reports" element={<WasteReports />} />
      <Route path="/reports/fridge-temperature-report" element={<FridgeTemperatureReport />} />
      <Route path="/reports/inventory-reports" element={<InventoryReports />} />
      <Route path="/reports/raw-waste-reports" element={<RawWasteReports />} />
      <Route path="/reports/cleaning-traceability" element={<CleaningTraceabilityReport />} />
      <Route path="/reports/stock-adjustment" element={<StockAdjustmentReports />} />
      <Route path="/reports/aftercook" element={<AftercookReport />} />
      <Route path="/reports/cold-traceability" element={<ColdTraceabilityReport />} />
      <Route path="/reports/hot-hold" element={<HotHoldReport />} />
      <Route path="/reports/cooling-process" element={<CoolingProcessReport />} />
      <Route path="/reports/reheat-process" element={<ReheatProcessReport />} />

      <Route path="/complaints/complaint-reply" element={<ReplyComplain />} />
      <Route path="/product-master-sheet" element={<ProtectedRoute permissions={['VIEW_PRODUCT']} element={<Product />} />} />
      <Route path="/product/:productName" element={<ProtectedRoute permissions={['VIEW_PRODUCT']} element={<ViewSingleProduct />} />} />
      <Route path="/good-inward-process" element={<ProtectedRoute permissions={['VIEW_GOODS_INWARD']} element={<GoodInward />} />} />
      <Route path="/masters/suppliers" element={<Suppliers />} />
      <Route
        path="/masters/suppliers/add-Supplier"
        element={<AddSuppliers />}
      />
      <Route
        path="/masters/suppliers/edit-Supplier"
        element={<EditSuppliers />}
      />
      <Route path="/masters/allergens" element={<Allergens />} />
      <Route
        path="/masters/allergens/add-allergens"
        element={<AddAllergens />}
      />
      <Route
        path="/masters/allergens/edit-allergens"
        element={<EditAllergens />}
      />
      <Route path="/masters/shelf-life" element={<OpenShelfLife />} />
      <Route
        path="/masters/shelf-life/add-shelf-life"
        element={<AddOpenShelfLife />}
      />
      
      <Route path="/masters/sensor/edit-sensor" element={<ProtectedRoute permissions={['EDIT_SENSOR']} element={<EditSensor />} />} />
      <Route path="/masters/sensor/add-sensor" element={<ProtectedRoute permissions={['ADD_SENSOR']} element={<AddSensor />} />} />
      <Route path="/masters/sensor" element={<ProtectedRoute permissions={['VIEW_SENSOR']} element={<Sensor />} />} />

      <Route path="/masters/storage-sensor" element={<ProtectedRoute permissions={['VIEW_STORAGE_SENSOR']} element={<StorageSensor />} />} />
      <Route path="/masters/storage-sensor/add-storage-sensor" element={<ProtectedRoute permissions={['ADD_STORAGE_SENSOR']} element={<AddStorageSensor />} />} />
      <Route path="/masters/storage-sensor/edit-storage-sensor" element={<ProtectedRoute permissions={['EDIT_STORAGE_SENSOR']} element={<EditStorageSensor />} />} />

      <Route path="/masters/storage-instructions/add-storage-instructions" element={<ProtectedRoute permissions={['ADD_STORAGE_INSTRUCTIONS']} element={<AddStorageInstructions />} />} />
      <Route path="/masters/storage-instructions/edit-storage-instructions" element={<ProtectedRoute permissions={['EDIT_STORAGE_INSTRUCTIONS']} element={<EditStorageInstructions />} />} />
      <Route path="/masters/storage-instructions" element={<ProtectedRoute permissions={['VIEW_STORAGE_INSTRUCTIONS']} element={<StorageInstructions />} />} />

      
      <Route path="/masters/storage-suggestions" element={<ProtectedRoute permissions={['VIEW_STORAGE_SUGGESTION']} element={<StorageSuggestion />} />} />
      <Route path="/masters/storage-suggestions/add-storage-suggestions" element={<ProtectedRoute permissions={['ADD_STORAGE_SUGGESTION']} element={<AddStorageSuggestion />} />} />
      <Route path="/masters/storage-suggestions/edit-storage-suggestions" element={<ProtectedRoute permissions={['EDIT_STORAGE_SUGGESTION']} element={<EditStorageSuggestion />} />} />
      <Route path="/masters/storage" element={<ProtectedRoute permissions={['VIEW_STORAGE']} element={<Storage />} />} />
      <Route path="/masters/storage/live-storage" element={<ProtectedRoute permissions={['VIEW_STORAGE']} element={<LiveSensor />} />} />
      <Route path="/masters/storage/add-storage" element={<ProtectedRoute permissions={['ADD_STORAGE']} element={<AddStorage />} />} />
      <Route path="/masters/storage/edit-storage" element={<ProtectedRoute permissions={['EDIT_STORAGE']} element={<EditStorage />} />} />
      <Route path="/production" element={<ProtectedRoute permissions={['VIEW_PRODUCTION']} element={<Production />} />} />
      <Route path="/cooling-process" element={<ProtectedRoute permissions={['VIEW_COOLING_PROCESS']} element={<CoolingProcess />} />} />
      <Route path="/after-cook" element={<ProtectedRoute permissions={['VIEW_AFTER_COOK']} element={<AfterCook />} />} />
      <Route path="/list-after-cook" element={<ListAfterCook />} />
      <Route path="/masters/Cooling-Shelf" element={<ProtectedRoute permissions={['VIEW_COOLING_SHELF_LIFE']} element={<CoolingShelf />} />} />
      <Route path="/masters/Cooling-Shelf/add-Cooling-Shelf" element={<ProtectedRoute permissions={['ADD_COOLING_SHELF_LIFE']} element={<AddCoolingShelf />} />} />
      <Route path="/masters/Cooling-Shelf/edit-Cooling-Shelf" element={<ProtectedRoute permissions={['EDIT_COOLING_SHELF_LIFE']} element={<EditCoolingShelf />} />} />

      <Route path="/company/profile" element={<ComapnyProfile />} />
      <Route path="/user-logs" element={<UserLogs />} />
    </Routes>
  );
};

export default RouteConfig;
